import type { TrackType } from "@/timeline";

export const DEFAULT_TRACK_NAMES: Record<TrackType, string> = {
	video: "Видеодорожка",
	text: "Текстовая дорожка",
	audio: "Аудиодорожка",
	graphic: "Графическая дорожка",
	effect: "Дорожка эффектов",
} as const;
